import React from 'react';
import { Divider, Stack, Text } from 'rsuite';
import { CheckRound, WarningRound, RunningRound } from '@rsuite/icons';

const ProgressIndicatorIcon = ({
  current,
  completed,
  size,
  completeColor = 'green',
  incompleteColor = 'red',
}) => {
  if (current) {
    return (
      <RunningRound
        aria-hidden="true"
        style={{
          fontSize: size,
          color: completeColor,
          marginTop: '-1px',
        }}
      />
    );
  } else if (completed) {
    return (
      <CheckRound
        aria-hidden="true"
        style={{
          fontSize: size,
          color: completeColor,
          marginTop: '-1px',
        }}
      />
    );
  } else {
    return (
      <WarningRound
        aria-hidden="true"
        style={{
          fontSize: size,
          color: incompleteColor,
          marginTop: '-1px',
        }}
      />
    );
  }
};

const FlowProgressIndicator = ({
  indicatorState,
  direction = 'vertical',
  currentStateIndex = 0,
}) => {
  return (
    <>
      {direction === 'vertical' ? (
        <Stack
          direction="column"
          alignItems="center"
          divider={
            <Divider
              vertical={true}
              style={{ backgroundColor: ' #C3C3C3' }}
            />
          }
        >
          {indicatorState.map((state, idx) => {
            const isCurrentStep = state.stepNum - 1 === currentStateIndex;
            // DECK-30021: active/completed steps use brand-600 background
            // with white icon, per design-spec. Incomplete steps keep the
            // neutral white/gray look.
            const isFilled = isCurrentStep || state.isCompleted;
            return (
              <div
                key={`indicator_state_${idx}`}
                aria-current={isCurrentStep ? 'step' : undefined}
                style={{
                  border: `1px solid ${isFilled ? '#116095' : '#C3C3C3'}`,
                  margin: 0,
                  borderRadius: '8px',
                  height: '58px',
                  width: '158px',
                  backgroundColor: isFilled ? '#116095' : 'white',
                }}
              >
                <Stack direction="row">
                  <Stack.Item
                    style={{
                      height: '58px',
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    <div
                      style={{
                        width: '58px',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <ProgressIndicatorIcon
                        completed={state.isCompleted}
                        current={isCurrentStep}
                        size="24px"
                        completeColor="#FFFFFF"
                        incompleteColor="#6e6e6e"
                      />
                    </div>
                  </Stack.Item>
                  <Stack.Item style={{ height: '58px', margin: 0 }}>
                    <div
                      style={{
                        width: '104px',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        paddingRight: '12px',
                      }}
                    >
                      <Text
                        className={`${isCurrentStep ? 'text-bold' : ''}`}
                        style={isFilled ? { color: '#FFFFFF' } : undefined}
                      >
                        {state?.stepName}
                      </Text>
                    </div>
                  </Stack.Item>
                </Stack>
              </div>
            );
          })}
        </Stack>
      ) : (
        <Stack
          direction="row"
          className="mb-16"
        >
          <Stack.Item>
            <Stack
              style={{
                border: '1px solid #C3C3C3',
                margin: 0,
                borderRadius: '25px',
                height: '50px',
                width: '50px',
              }}
            >
              <Stack.Item style={{ width: '100%' }}>
                <Text style={{ textAlign: 'center' }}>
                  {currentStateIndex} of {indicatorState.length}
                </Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item style={{ width: '100%' }}>
            <Stack
              direction="column"
              alignItems="flex-start"
              className="ph-16 pv-8"
            >
              <Text
                className="text-large text-bold"
                style={{ textAlign: 'left' }}
              >
                {indicatorState[currentStateIndex - 1]?.stepName}
              </Text>
              {currentStateIndex !== indicatorState.length && (
                <Text
                  className="text-italic"
                  style={{ textAlign: 'left' }}
                >
                  Next: {indicatorState[currentStateIndex]?.stepName}
                </Text>
              )}
            </Stack>
          </Stack.Item>
        </Stack>
      )}
    </>
  );
};

export default FlowProgressIndicator;
